import axios from 'axios'

const API_URL = process.env.VUE_APP_QUOTE_API

const api = axios.create({
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
  baseURL: API_URL,
})

export default api
